<div class="mkt-email-template-dialog">
  <!-- Template headers -->
  <div class="template-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-bullseye header-icon"></i>

        <div class="template-description width-100p p-relative">
          <app-input id="template-name" type="text" theme="secondary" placeholder="Template name*"
            [disabled]="isOpenedFromScheduledFollowups" styleClassInput="width-100p" [maxLength]="100" [fontSize]="14"
            [value]="template?.name" [errorMessage]="" [isInvalid]="errors?.name"
            (appChange)="handleChange('name', $event)">
          </app-input>
        </div>

        <i id="template-close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog()"></i>
      </div>
    </div>
  </div>
  <!-- Template headers End-->

  <!-- Template body starts -->
  <div class="ui-g template-body pt-0 pb-0">
    <div class="ui-g-12 inputs-column-spacing template-inner-body">
      <h4 class="font-14 font-gray-45 font-bold">Basic info</h4>

      <!-- Basic info -->
      <div class="ui-g-12 p-0 input-default-style">
        <!-- Template Type -->
        <div class="ui-g-{{template.campaignType === campaignTypes.FOLLOWUP? '4' : '6'}} p-0 flex-start-center mt-3">
          <div class="icon flex-center-start">
            <i class="far fa-stream height-icon font-14"></i>
          </div>

          <div class="width-100p pl-1 pr-2">
            <app-input id="template-type" type="text" placeholder="Template type" theme="light" [fontSize]="14"
              value="Email" [floatingLabel]="true" [disabled]="true" [maxLength]="50">
            </app-input>
          </div>
        </div>

        <!-- Campaign type -->
        <div class="ui-g-{{template.campaignType === campaignTypes.FOLLOWUP? '4' : '6'}} p-0 flex-start-center mt-3">
          <div class="icon flex-center-start">
            <i class="far fa-stream height-icon font-14"></i>
          </div>

          <div class="width-100p pl-1 pr-2">
            <app-dropdown id="campaign-type" type="text" placeholder="Campaign type" theme="light" [fontSize]="14"
              [isDropdownIconVisible]="true" [floatingLabel]="true" [disabled]="true"
              [value]="{name: template.campaignType === campaignTypes.FOLLOWUP? 'Follow-up' : 'Promotional'}">
            </app-dropdown>
          </div>
        </div>

        <!-- Follow-up event -->
        <div *ngIf="template.campaignType === campaignTypes.FOLLOWUP" class="ui-g-4 p-0 flex-start-center mt-3">
          <div class="icon flex-center-start">
            <i class="far fa-stream height-icon font-14"></i>
          </div>

          <div class="width-100p pl-1 pr-2">
            <app-dropdown id="follow-event-type" type="text" placeholder="Follow-up event" theme="light"
              itemWidth="205px" scrollHeight="200px" hPosition="right" [fullyControlled]="true"
              [disabled]="campaignTemplateId" [fontSize]="14" [isDropdownIconVisible]="true" [options]="followUpEvents"
              [value]="template?.followUpEvent" [floatingLabel]="true" [hasError]="errors?.followUpEvent"
              [errorMessage]="errors?.followUpEvent" (appSelect)="handleChange('followUpEvent', $event)">
            </app-dropdown>
          </div>
        </div>
      </div>

      <!-- Subject -->
      <div class="ui-g-12 p-0 input-default-style">
        <div class="ui-g-12 p-0 flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-envelope height-icon font-14"></i>
          </div>

          <div class="width-100p pl-1">
            <app-input id="template-subject" type="text" placeholder="Email subject (EN)" theme="light" [fontSize]="14"
              [value]="template.subject" [disabled]="isReadOnly || isOpenedFromScheduledFollowups"
              [isInvalid]="errors.subject" [floatingLabel]="true" [maxLength]="100" (appFocus)="errors.subject = ''"
              (appChange)="handleChange('subject', $event)">
            </app-input>
          </div>
        </div>
      </div>


      <div class="ui-g-12 p-0 input-control-container">
        <div class="ui-g-12 p-0 flex-start-center">
          <div class="icon flex-center-start align-self-start mt-2">
            <i class="far fa-bullseye-arrow height-icon"></i>
          </div>
          <div class="width-100p textarea" [ngClass]="{'invalid': errors?.text}">
            <label class="font-11 font-gray-45 mb-1 font-normal">
              Campaign text {{ companyLocalization ? '(EN)' : '' }}
            </label>

            <app-textarea (appFocus)="onFocusEN()" theme="border" styleClassInput="p-1" textAreaId="template-text"
              placeholder="Template text" [floatingLabel]="false" [disabled]="isReadOnly" [autoGrow]="true" errorClass="template-text-area-error-email"
              [maxAutoGrowHeight]="200" [maxLength]="10000" [fontSize]="14" [value]="template.text" [errorMessage]="errors?.text" errorIcon="fal fa-info-circle"
              [isInvalid]="errors?.text" (appFocus)="errors.text = ''" (appBlur)="onBlur('text')" (appChange)="handleChange('text', $event)">
            </app-textarea>
          </div>
        </div>
      </div>

      <div class="ui-g-12 pt-3 input-default-style" [ngClass]="{'pt-5':isSMSCampaignLimitEnabled}" *ngIf="companyLocalization">
        <div class="ui-g-12 p-0 flex-start-center">
          <div class="icon flex-center-start">
            <i class="far fa-envelope height-icon font-14"></i>
          </div>

          <div class="width-100p pl-1">
            <app-input id="template-subject" type="text" placeholder="Email subject (FR)" theme="light" [fontSize]="14"
              [value]="template.subjectFR" [disabled]="isReadOnly || isOpenedFromScheduledFollowups"
              [isInvalid]="errors.subjectFR" [floatingLabel]="true" [maxLength]="100" (appFocus)="errors.subjectFR = ''"
              (appChange)="handleChange('subjectFR', $event)">
            </app-input>
          </div>
        </div>
      </div>


      <div class="ui-g-12 p-0 input-control-container" *ngIf="companyLocalization">
        <div class="ui-g-12 p-0 flex-start-center">
          <div class="icon flex-center-start align-self-start mt-2">
            <i class="far fa-bullseye-arrow height-icon"></i>
          </div>
          <div class="width-100p textarea" [ngClass]="{'invalid': errors?.textFR}">
            <label class="font-11 font-gray-45 mb-1 font-normal">
              Campaign text (FR)
            </label>

            <app-textarea (appFocus)="onFocusFR()" theme="border" styleClassInput="p-1" textAreaId="template-text-fr"
              placeholder="Template text" [floatingLabel]="false" [disabled]="isReadOnly" [autoGrow]="true" errorClass="template-text-area-error-email"
              [maxAutoGrowHeight]="200" [maxLength]="10000" [fontSize]="14" [value]="template.textFR" [errorMessage]="errors?.textFR" errorIcon="fal fa-info-circle"
              [isInvalid]="errors?.textFR" (appFocus)="errors.textFR = ''" (appBlur)="onBlur('textFR')" (appChange)="handleChange('textFR', $event)">
            </app-textarea>
          </div>
        </div>
      </div>

      <!-- Tags -->
      <div class="ui-g-12 p-0 input-control-container mt-20" [ngClass]="{'not-allowed': isReadOnly, 'mt-30':isSMSCampaignLimitEnabled}">
        <div class="ui-g-12 p-0 flex-start-center">
          <div class="icon flex-center-start align-self-start mt-2">
            <i class="far fa-tags font-14 height-icon"></i>
          </div>

          <div class="width-100p">
            <label class="font-11 font-gray-45 mb-1 font-normal">
              Customer Tags
            </label>

            <div class="badge-al">
              <span class="badge badge-pill badge-primary"
                [ngClass]="{'not-allowed': isReadOnly, 'pointer': !isReadOnly}"
                (click)="insertEmbedding(embeddings.CUSTOMER_FIRST_NAME)">
                First name
              </span>
              <span class="badge badge-pill badge-primary"
                [ngClass]="{'not-allowed': isReadOnly, 'pointer': !isReadOnly}"
                (click)="insertEmbedding(embeddings.CUSTOMER_LAST_NAME)">
                Last name
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Shop tags -->
      <div class="ui-g-12 p-0 input-control-container mt-20" [ngClass]="{'not-allowed': isReadOnly}">
        <div class="ui-g-12 p-0 flex-start-center">
          <div class="icon flex-center-start align-self-start mt-2">
            <i class="far font-14 fa-tags height-icon"></i>
          </div>
          <div class="width-100p">
            <label class="font-11 font-gray-45 mb-1 font-normal">
              Shop Tags
            </label>

            <div class="badge-al">
              <span class="badge badge-pill badge-primary"
                [ngClass]="{'not-allowed': isReadOnly, 'pointer': !isReadOnly}"
                (click)="insertEmbedding(embeddings.SHOP_NAME)">
                Shop Name
              </span>

              <span class="badge badge-pill badge-primary"
                [ngClass]="{'not-allowed': isReadOnly, 'pointer': !isReadOnly}"
                (click)="insertEmbedding(embeddings.SHOP_CONTACT_NUMBER)">
                Contact Number
              </span>

              <span *ngIf="isShowApptRequestTag" class="badge badge-pill badge-primary"
                [ngClass]="{'not-allowed': isReadOnly, 'pointer': !isReadOnly}"
                (click)="insertEmbedding(embeddings.APPT_REQUEST)">
                Appointment Request
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Event tags -->
      <div class="ui-g-12 p-0 input-control-container mt-20" *ngIf="eventTags?.length"
        [ngClass]="{'not-allowed': isReadOnly}">
        <div class="ui-g-12 p-0 flex-start-center">
          <div class="icon flex-center-start align-self-start mt-2">
            <i class="far font-14 fa-tags height-icon"></i>
          </div>
          <div class="width-100p">
            <label class="font-11 font-gray-45 mb-1 font-normal">
              Event Tags
            </label>

            <div class="badge-al">
              <span class="badge badge-pill badge-primary"
                [ngClass]="{'not-allowed': isReadOnly, 'pointer': !isReadOnly}" *ngFor="let tag of eventTags"
                (click)="insertEmbedding(tag?.value)">
                {{tag?.label}}
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- SMS -->
      <div *ngIf="!isOpenedFromScheduledFollowups" class="input-basic-info-wrapper ui-g-12 p-0 mt-20 pb-2">
        <div class="input-default-style mb-0">
          <h4 class="font-14 font-gray-45 font-bold mb-2">
            Send a preview email
          </h4>
          <div class="ui-g-12 p-0 input-control-container mt-1">
            <div class="ui-g-12 p-0 flex-start-center">
              <div class="icon flex-center-start">
                <i class="far fa-envelope height-icon font-14"></i>
              </div>

              <div class="width-100p template-contact-info-wrapper">
                <app-input id="template-test-email" type="text" placeholder="Email" style="flex: 0 0 275px;"
                  theme="light" maxlength="50" [fontSize]="14" [errorMessage]="errors.email" [isInvalid]="errors.email"
                  [floatingLabel]="true" [value]="template.email" (appFocus)="errors.email = ''"
                  (appChange)="handleChange('email', $event)">
                </app-input>

                <button type="button" class="btn btn-outline-secondary py-1 align-self-center"
                  [disabled]="!template?.email || !template?.subject || isSending" (click)="sendPreviewEmail()">
                  <span [ngClass]="{'pr-2': isSending}">Send preview</span>
                  <i *ngIf="isSending" class="fal fa-spinner rotate"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Template body ends -->

  <!-- Start Add Parts Footer -->
  <div class="ui-g-12 flex-between-center dialog-footer part-footer p-3">
    <div class="part-add-dialog-footer d-flex justify-content-between width-100p">
      <div class="align-self-center">
        <span *ngIf="isOpenedFromCampaign && !isReadOnly" class="width-100p">
          <app-checkbox inputId="update-campaign-global-flag" label="Also update template across application"
            [isChecked]="isUpdateMasterTemplate" (appChange)="isUpdateMasterTemplate = $event">
          </app-checkbox>
        </span>
      </div>

      <div>
        <button id="template-cancel-btn" class="btn btn-white btn-border pointer btn-submit mr-2"
          (click)="closeDialog()">
          Cancel
        </button>

        <button id="template-save-btn" class="btn btn-primary btn-submit "
          [disabled]="isReadOnly || isProcessing || isLoading || isSending" (click)="onSave()">
          <span [ngClass]="{'pr-2': isProcessing || isLoading}">Save</span>
          <i *ngIf="isProcessing || isLoading" class="far fa-spinner rotate"></i>
        </button>
      </div>
    </div>
  </div>
  <!-- End Add Parts Footer -->
</div>